$(document).ready(function () {
  // ------------------- TB_Services_CMS Start -------------------
    var tb_services_cms = $('#tb-services-cms .tb-services-cms-wrapper').owlCarousel({
      items: 4,
      nav: false,
      dots: false,
      loop: false,
      center: false,
      autoplayHoverPause: true,
      autoplay: true,
      rtl: false,
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 3
        },
        1500: {
          items: 4
        }
      }
    });
    // ------------------- TB_Services_CMS End -------------------
  // ------------------- TB_Testimonial-CMS Start -------------------
  var tb_testimonial_cms = $("#TB-Testimonial-cms .owl-carousel").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
        margin: 15,
      },
      768: {
        items: 2,
        margin: 15,
      },
      992: {
        items: 2,
        margin: 15,
      },
      1200: {
        items: 3,
        margin: 10,
      },
      1300: {
        items: 3,
        margin: 10,
      },
      1400: { items: 3 },
    },
  });
  // ------------------- TB_Testimonial-CMS End -------------------
  // ------------------- TB-Category Featured Start -------------------

  $(document).ready(function () {
      $('#TB-category-featured .owl-carousel').owlCarousel({
        items: 6,
        nav: false,
        dots: true,
        loop: false,
        autoplay: true,
        margin: 30,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1 },
          480: { items: 2, margin: 15 },
          768: { items: 3 },
          992: { items: 4 },
          1200: { items: 4 },
          1400: { items: 5 },
          1500:{items: 6}
        }
      });
    });

  // ------------------- TB-Category Featured End -------------------
});
